import { mergeClassnames } from '@porterin/component-library/src/utils/mergeClassnames';
import React, { forwardRef } from 'react';

type checkboxInteractions = {
  onChange?: (checked: boolean) => void;
};

type checkboxOptions = {
  disabled?: boolean;
  checked?: boolean;
  value: string;
  label: string | JSX.Element;
  labelClass?: string;
};

type identifiers = {
  id: string;
};

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  identifiers: identifiers;
  interactions?: checkboxInteractions;
  checkboxOptions?: checkboxOptions;
  className?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { identifiers, interactions, checkboxOptions, className = '', ...props },
    ref,
  ) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (interactions?.onChange) {
        interactions.onChange(event.target.checked);
      }
    };

    return (
      <div
        className={mergeClassnames('flex items-center space-x-3', className)}
      >
        <input
          value={checkboxOptions?.value}
          id={identifiers.id}
          ref={ref}
          type="checkbox"
          checked={checkboxOptions?.checked}
          disabled={checkboxOptions?.disabled ?? false}
          onChange={handleChange}
          className={mergeClassnames(
            `h-6 w-6 rounded
            text-[#0A57FF]  // TODO: Use it from TW config after adding theme
						disabled:cursor-not-allowed disabled:opacity-50`,
          )}
          {...props}
        />
        <label
          htmlFor={identifiers.id}
          className={mergeClassnames(
            `text-xl font-normal text-gray-800`,
            checkboxOptions?.disabled ? 'text-gray-400' : '',
            checkboxOptions?.labelClass ?? '',
          )}
        >
          {checkboxOptions?.label}
        </label>
      </div>
    );
  },
);
Checkbox.displayName = 'Checkbox';

export default Checkbox;
